import React from 'react'
import PropTypes from 'prop-types'

import './or-spacer.pcss'

const OrSpacer = ({ t }) => {
    return <div className="or-spacer">{t('common:or')}</div>
}

OrSpacer.propTypes = {
    t: PropTypes.func.isRequired,
}

export default OrSpacer
